export enum DatePickerType {
    Default = 'default',
    Range = 'range',
}
